export default "__VITE_ASSET__821422f3__"